import React, { Component } from "react";

import "bootstrap/dist/css/bootstrap.min.css";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
//import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";


export default class QuarantineGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onRowDoubleClicked = this.onRowDoubleClicked.bind(this);

    this.columnDefs = [
      {headerName: "Id", field: "quarantineId", sortable: true, filter: true, resizable: true, maxWidth: 400, cellStyle: this.lineStatusStyle},
      {headerName: "Receipt Id", field: "sourceReceipt.tagId", sortable: true, filter: true, resizable: true, maxWidth: 120},
      {headerName: "MRA Id", field: "sourcePallet.glasschainId", sortable: true, filter: true, resizable: true, maxWidth: 400},
      {headerName: "Lot", field: "sourceReceipt.lot", sortable: false, filter: true, resizable: true, maxWidth: 120},
      {headerName: "Block", field: "sourceLine.blockName", sortable: false, filter: true, resizable: true, maxWidth: 120},
      {headerName: "Lot", field: "sourceReceipt.lot", sortable: false, filter: true, resizable: true, maxWidth: 120},
      {headerName: "Variety", field: "sourceLine.varietyName", sortable: false, filter: true, resizable: true, maxWidth: 120},
      {headerName: "Qty", field: "sourcePallet.unitQty", sortable: false, filter: true, resizable: true, maxWidth: 120},
    ];
    
  }


  lineStatusStyle(params){
      return {'background-color': 'green'};
  }

  onSelectionChanged() {
    console.log("Changing selected row")
    var selectedNodes = this.gridApi.getSelectedNodes();
    var rowData = selectedNodes[0].data;
    //var rowNode = selectedNodes[0];
    this.props.onRowSelectChange(rowData); 
  }

  onRowDoubleClicked(row){
    console.group("On Row Double Clicked Row: ");
    console.log(row.data);
    console.groupEnd();
    var rowData = row.data;
    this.props.onRowSelectChange(rowData);
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };

  render() {
    const divStyle = {
      width: "100%",
      height: "calc(45vh)",
      maxWidth: "99vw",
      margin: "5px",
      //border: '5px solid black'
    };

    const gridOptions = {
      onRowDoubleClicked: this.onRowDoubleClicked
    }

    if (this.dataReady){
      console.log(" Lines (this.props.rowData) about to be rendered: ");
      console.log(this.props.rowData);
      this.gridApi.setRowData(this.props.rowData);
    }

    return (
      <div className="ag-theme-balham" style={divStyle}>
        <AgGridReact
          rowSelection="single"
          enableRangeSelection={true}
          pagination={true}
          columnDefs={this.columnDefs}
          rowData={this.props.rowData}
          animateRows={true}
          onGridReady={this.onGridReady}
          onSelectionChanged={this.onSelectionChanged.bind(this)}
          gridOptions = {gridOptions}
        />
      </div>
    );
  }
}
